module.exports = __webpack_public_path__ + "static/img/chocolatethills.a477cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/chocolatethills.jpg
// module id = It2R
// module chunks = 1